import React, { useEffect, useRef } from 'react';

import BaseSelect from '$partials/fields/select.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings.d.ts').PropertySortInput}
 */
const PropertySortInput = ({
    allowDistance = false,
    className,
    onChange,
    value,
}) => {
    /** @type {React.MutableRefObject<boolean>} */
    const previousAllowDistanceRef = useRef();

    let sortOptions = [
        { label: 'Newest', value: 'newest' },
        { label: 'Price (low to high)', value: 'price' },
        { label: 'Price (high to low)', value: '-price' },
    ];
    if (allowDistance) {
        sortOptions.unshift({ label: 'Distance', value: 'distance' });
    }
    const sortOption = sortOptions.find((opt) => opt.value === value);
    const sortLabel = sortOption ? sortOption?.label : sortOptions[0]?.label;

    useEffect(() => {
        if (previousAllowDistanceRef.current !== undefined && previousAllowDistanceRef.current !== allowDistance) {
            previousAllowDistanceRef.current = allowDistance;
            onChange(null);
        }
    }, [allowDistance]);

    return (
        <BaseSelect
            displayValue={`Sort by: ${sortLabel}`}
            name='sort'
            onChange={onChange}
            options={sortOptions}
            triggerClassName={className}
            value={value} />
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default PropertySortInput;
